/* Quiet Haven product page behaviour.
   Only reads and changes elements inside .qh-page wrappers. Loaded with defer from the
   quiet-haven sections; the guard below stops it running twice when several sections load it. */
(function () {
  'use strict';

  if (window.quietHavenLoaded) return;
  window.quietHavenLoaded = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var MOBILE_MAX = 767;

  function scrollBehavior() {
    return reducedMotion.matches ? 'auto' : 'smooth';
  }

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  /* Links that jump to another part of the Quiet Haven page (e.g. #qh-packs). */
  function initScrollLinks(page) {
    each(page.querySelectorAll('a[data-qh-scroll]'), function (link) {
      link.addEventListener('click', function (event) {
        var id = (link.getAttribute('href') || '').replace(/^#/, '');
        var target = id && document.getElementById(id);
        if (!target || !target.closest('.qh-page')) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
        var focusTarget = target.querySelector('input[data-qh-pack]:checked') || target;
        focusTarget.focus({ preventScroll: true });
      });
    });
  }

  /* Testimonial carousel: native horizontal scrolling with snap, plus arrows and dots. */
  function initCarousel(root) {
    var track = root.querySelector('[data-qh-track]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-qh-slide]');
    var section = root.closest('.qh-page') || root;
    var dots = section.querySelectorAll('[data-qh-dot]');
    var prev = root.querySelector('[data-qh-prev]');
    var next = root.querySelector('[data-qh-next]');

    function step() {
      if (slides.length > 1) return slides[1].offsetLeft - slides[0].offsetLeft;
      return track.clientWidth || 1;
    }
    function lastIndex() {
      return Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / step()));
    }
    function currentIndex() {
      return Math.round(track.scrollLeft / step());
    }
    function goTo(index) {
      var last = lastIndex();
      if (index > last) index = 0;
      if (index < 0) index = last;
      track.scrollTo({ left: index * step(), behavior: scrollBehavior() });
    }
    function syncDots() {
      var index = currentIndex();
      each(dots, function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });
    each(dots, function (dot) {
      dot.addEventListener('click', function () { goTo(Number(dot.getAttribute('data-qh-dot'))); });
    });

    var queued = false;
    track.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        syncDots();
      });
    }, { passive: true });
  }

  /* Product gallery: thumbnails switch the main image. */
  function initGallery(root) {
    var slides = root.querySelectorAll('[data-qh-media]');
    var thumbs = root.querySelectorAll('[data-qh-thumb]');
    var strip = root.querySelector('[data-qh-thumbs]');
    if (!thumbs.length) return;

    function show(index) {
      each(slides, function (slide, i) { slide.hidden = i !== index; });
      each(thumbs, function (thumb, i) { thumb.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      // Keep the active thumbnail visible in the scrolling strip (mobile) without moving the page.
      if (strip && strip.scrollWidth > strip.clientWidth) {
        var item = thumbs[index].parentElement;
        var left = item.offsetLeft - (strip.clientWidth - item.offsetWidth) / 2;
        strip.scrollTo({ left: Math.max(0, left), behavior: scrollBehavior() });
      }
    }

    each(thumbs, function (thumb) {
      thumb.addEventListener('click', function () { show(Number(thumb.getAttribute('data-qh-thumb'))); });
    });
  }

  /* Buy box: pack selector, the Subscribe & Save checkbox, and the add to cart form state.
     All prices are pre-formatted in Liquid (data attributes on each pack radio); this only swaps text. */
  function initBuyBox(root) {
    var idInput = root.querySelector('[data-qh-variant-input]');
    var button = root.querySelector('[data-qh-atc]');
    var buttonLabel = button ? button.querySelector('span') : null;
    var planInput = root.querySelector('[data-qh-plan-input]');
    var planSelect = root.querySelector('[data-qh-plan]');
    var subscribe = root.querySelector('[data-qh-subscribe]');
    var subNote = root.querySelector('[data-qh-sub-note]');
    var subPrice = root.querySelector('[data-qh-sub-price]');
    var stock = root.querySelector('[data-qh-stock]');
    var packs = root.querySelectorAll('[data-qh-pack]');

    function currentPlanId() {
      if (!planInput || !subscribe || !subscribe.checked) return '';
      return planSelect ? planSelect.value : planInput.value;
    }

    // Reads one price set from a pack radio: the selling plan's if it has one, else one-time.
    function pricesFor(pack, planId) {
      var prefix = planId && pack.hasAttribute('data-plan-' + planId + '-price') ? 'data-plan-' + planId + '-' : 'data-';
      return {
        price: pack.getAttribute(prefix + 'price') || '',
        save: pack.getAttribute(prefix + 'save') || '',
        unit: pack.getAttribute(prefix + 'unit') || '',
        sale: pack.getAttribute(prefix + 'sale') === 'true'
      };
    }

    function setText(el, text) {
      if (el && el.textContent !== text) el.textContent = text;
    }

    function renderCards(planId) {
      each(packs, function (pack) {
        var card = pack.closest('.qh-pack');
        if (!card) return;
        var p = pricesFor(pack, planId);
        setText(card.querySelector('[data-qh-pack-price]'), p.price);
        var unit = card.querySelector('[data-qh-pack-unit]');
        setText(unit, p.unit);
        var save = card.querySelector('[data-qh-pack-save]');
        if (save) {
          setText(save, p.save);
          save.hidden = !p.save;
        }
        var compare = card.querySelector('[data-qh-pack-compare]');
        if (compare) compare.hidden = !p.sale;
      });
    }

    function update() {
      var pack = root.querySelector('[data-qh-pack]:checked');
      var planId = currentPlanId();

      if (planInput) {
        if (planSelect) planInput.value = planSelect.value;
        // Only toggle when the checkbox is on the page (a required plan stays enabled).
        if (subscribe) planInput.disabled = !subscribe.checked;
      }

      renderCards(planId);

      if (pack) {
        var available = pack.getAttribute('data-available') === 'true';
        if (idInput) idInput.value = pack.value;
        if (button) {
          button.disabled = !available;
          if (buttonLabel) {
            buttonLabel.textContent = available
              ? button.getAttribute('data-label-add')
              : button.getAttribute('data-label-soldout');
          }
        }
        if (stock) stock.hidden = !available;
        if (subPrice && planInput) {
          var planForNote = planSelect ? planSelect.value : planInput.value;
          setText(subPrice, pack.getAttribute('data-plan-' + planForNote + '-price') || '');
        }
      }
      if (subNote) subNote.hidden = !(subscribe && subscribe.checked);
    }

    each(packs, function (pack) { pack.addEventListener('change', update); });
    if (subscribe) subscribe.addEventListener('change', update);
    if (planSelect) {
      planSelect.addEventListener('change', function () {
        if (subscribe && !subscribe.checked) subscribe.checked = true;
        update();
      });
    }
    // Browsers can restore radio state on back/forward navigation; resync the form.
    window.addEventListener('pageshow', update);
    update();
  }

  /* Mobile sticky bar: visible after the main Add to Cart scrolls out of view, hidden near the footer. */
  function initSticky(root) {
    var bar = root.querySelector('[data-qh-sticky]');
    var end = root.querySelector('[data-qh-sticky-end]');
    if (!bar) return;
    var queued = false;

    function check() {
      queued = false;
      var atc = document.querySelector('.qh-page [data-qh-atc]');
      var show = false;
      if (atc && window.innerWidth <= MOBILE_MAX) {
        var pastButton = atc.getBoundingClientRect().bottom < 0;
        var beforeEnd = !end || end.getBoundingClientRect().top > window.innerHeight;
        show = pastButton && beforeEnd;
      }
      if (bar.hidden === show) bar.hidden = !show;
    }
    function queue() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(check);
    }

    var stickyButton = root.querySelector('[data-qh-sticky-atc]');
    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        var atc = document.querySelector('.qh-page [data-qh-atc]');
        if (atc && !atc.disabled && atc.getAttribute('aria-disabled') !== 'true') {
          // Same form as the main button: selected pack, and selling_plan only when Subscribe is chosen.
          atc.click();
          return;
        }
        var target = document.getElementById('qh-packs');
        if (target) target.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
      });
    }

    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    check();
  }

  function init(scope) {
    var pages = [];
    if (scope.matches && scope.matches('.qh-page')) pages.push(scope);
    each(scope.querySelectorAll('.qh-page'), function (page) { pages.push(page); });

    pages.forEach(function (page) {
      if (page.hasAttribute('data-qh-ready')) return;
      page.setAttribute('data-qh-ready', '');
      initScrollLinks(page);
      each(page.querySelectorAll('[data-qh-carousel]'), initCarousel);
      each(page.querySelectorAll('[data-qh-gallery]'), initGallery);
      if (page.hasAttribute('data-qh-buybox')) initBuyBox(page);
      if (page.hasAttribute('data-qh-sticky-root')) initSticky(page);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme editor: re-run for sections that are added or re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
